
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { usePermissions } from "../../../UserPermissions.js";
import { RoleId__get_unwrap } from "../../../Shared/Shared.js";
import { PermissionGroupSection, PermissionScopeLegend, visibleGroups } from "../PermissionTables.js";
import { join, concat } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { PermissionGroup__ToI18nString, RoleDefinitionModule_isAssignable, Permission, Permissions_has, PermissionGroup__get_Key } from "../../../Shared/Roles.js";
import { filter, length, tryFind, ofArray, head } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { reactElement, reactApi } from "../../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { equals, int32ToString, createObj } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { RoleDeleteDialog } from "../Dialogs/RoleDeleteDialog.js";
import { Msg } from "./Types.js";
import { DetailViewHeader } from "../../../Widgets/DetailViewHeader.js";
import { roleDisplayName } from "../../../Common.js";
import { append, map, singleton, delay, toList } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { defaultOf } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { Badge } from "../../../Components/Badge.js";
import { RouterModule_nav } from "../../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { unwrap } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { AreaAnchorMenu } from "../../../Widgets/AnchorMenu.js";
import { SectionContainer } from "../../../Widgets/Container.js";
import { LabeledValue } from "../../../Components/Text.js";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, init as init_1 } from "./State.js";
import { Skeleton } from "../../../Components/Skeleton.js";

function RoleDetail(props) {
    let elems_5, elems_4, elems, Title, elems_1, elems_3;
    const t = useTranslation()[0];
    const permissions = usePermissions();
    const roleId = RoleId__get_unwrap(props.Definition.Id);
    const groups = visibleGroups(props.AccountSettings);
    const anchorId = (group) => concat("permission-group-", ...PermissionGroup__get_Key(group));
    let patternInput_1;
    const initial = anchorId(head(groups));
    patternInput_1 = reactApi.useState(initial);
    return reactElement("div", createObj(ofArray([["className", "flex grow flex-col"], (elems_5 = [createElement(RoleDeleteDialog, {
        Definition: props.Definition,
        IsOpen: props.IsDeleteDialogOpen,
        OnClose: () => {
            props.Dispatch(new Msg(4, []));
        },
        OnDeleted: () => {
            props.Dispatch(new Msg(5, []));
        },
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-[10rem,minmax(0,80rem)]"])], (elems_4 = [reactElement("div", createObj(ofArray([["className", join(" ", ["col-span-2"])], (elems = [createElement(DetailViewHeader, (Title = roleDisplayName(t, props.Definition), {
        Badges: toList(delay(() => ((props.Definition.SystemKey == null) ? singleton(defaultOf()) : singleton(createElement(Badge, {
            Color: "#B6BECB",
            Label: t("settings.roles.system_role"),
            TestId: "role-system-badge",
        }))))),
        OnBack: () => {
            RouterModule_nav(ofArray(["settings", "roles"]), 1, 1);
        },
        OnDelete: unwrap((props.Definition.SystemKey == null) ? (Permissions_has(permissions, new Permission(61, [])) ? (() => {
            props.Dispatch(new Msg(3, []));
        }) : undefined) : undefined),
        OnDuplicate: unwrap((RoleDefinitionModule_isAssignable(props.Definition) && Permissions_has(permissions, new Permission(59, []))) ? (() => {
            RouterModule_nav(ofArray(["settings", "roles", roleId, "copy"]), 1, 1);
        }) : undefined),
        OnEdit: unwrap(Permissions_has(permissions, new Permission(60, [])) ? (() => {
            RouterModule_nav(ofArray(["settings", "roles", roleId, "edit"]), 1, 1);
        }) : undefined),
        Title: Title,
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["print:hidden"])], (elems_1 = [createElement(AreaAnchorMenu, {
        Anchors: toList(delay(() => map((group_1) => ({
            Id: anchorId(group_1),
            Label: t(PermissionGroup__ToI18nString(group_1)),
        }), groups))),
        OnSelectAnchor: patternInput_1[1],
        SelectedAnchor: patternInput_1[0],
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems_3 = toList(delay(() => {
        let elems_2;
        return append(singleton(createElement(SectionContainer, {
            Content: reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems_2 = [LabeledValue({
                Label: t("general.name"),
                Value: roleDisplayName(t, props.Definition),
            }), LabeledValue({
                Label: t("settings.roles.kind"),
                Value: (props.Definition.SystemKey == null) ? t("settings.roles.custom_role") : t("settings.roles.system_role"),
            }), LabeledValue({
                Label: t("settings.roles.assigned_users"),
                Value: int32ToString(props.AssignedUsers),
            })], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))),
        })), delay(() => append(singleton(createElement(PermissionScopeLegend, null)), delay(() => map((group_2) => PermissionGroupSection({
            ComponentState: "disabled",
            Group: group_2,
            OnChange: (_arg_6, _arg_7) => {
            },
            Permissions: props.Definition.Permissions,
            Storages: props.Storages,
        }), groups)))));
    })), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])));
}

export function RoleDetailView(props) {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init_1, update_1, (_arg, _arg_1) => {
    }), props.RoleId, undefined);
    const state_1 = patternInput[0];
    const matchValue = state_1.Roles;
    const matchValue_1 = state_1.Assignments;
    const matchValue_2 = state_1.Storages;
    let matchResult, assignments, roles, storages;
    if (matchValue.tag === 1) {
        if (matchValue_1.tag === 1) {
            if (matchValue_2.tag === 1) {
                matchResult = 0;
                assignments = matchValue_1.fields[0];
                roles = matchValue.fields[0];
                storages = matchValue_2.fields[0];
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            const matchValue_4 = tryFind((role) => equals(role.Id, props.RoleId), roles);
            if (matchValue_4 == null) {
                return defaultOf();
            }
            else {
                const role_1 = matchValue_4;
                return createElement(RoleDetail, {
                    AccountSettings: props.AccountSettings,
                    AssignedUsers: length(filter((assignment) => equals(assignment.RoleId, role_1.Id), assignments)),
                    Definition: role_1,
                    Dispatch: patternInput[1],
                    IsDeleteDialogOpen: state_1.IsDeleteDialogOpen,
                    Storages: storages,
                });
            }
        }
        default:
            return createElement(Skeleton, {
                Variant: "detail",
            });
    }
}

